import { DatadogRUM, DatadogRUMUser } from '@nx-frontend/shared/types';

interface WindowWithDDRUM extends Window {
  DD_RUM?: DatadogRUM;
}

function getDDRUM(): DatadogRUM | null {
  if (typeof window === 'undefined') {
    return null;
  }
  const windowWithDDRUM = window as unknown as WindowWithDDRUM;
  if (windowWithDDRUM.DD_RUM) {
    return windowWithDDRUM.DD_RUM;
  }
  return null;
}

export function rumIsAvailable(): boolean {
  return !!getDDRUM();
}

export function rumIsIinitialized(): boolean {
  const ddRum = getDDRUM();
  if (!ddRum) {
    return false;
  }
  return !!ddRum.getInitConfiguration();
}

export function rumInit(options: Record<string, unknown>) {
  const ddRum = getDDRUM();
  if (!ddRum) {
    return;
  }
  ddRum.init(options);
}

export function rumSetUser(user: DatadogRUMUser) {
  const ddRum = getDDRUM();
  if (!ddRum) {
    return;
  }
  ddRum.setUser(user);
}

/**
 * Adds an error to the Datadog RUM Session.
 * @param err
 * @returns
 */
export function rumTrackError(err: Error) {
  const ddRum = getDDRUM();
  if (!ddRum) {
    return;
  }
  ddRum.addError(err);
}

/**
 * Adds an action to the Datadog RUM Session.
 * @param err
 * @returns
 */
export function rumTrackAction(action: string, data: Record<string, unknown>) {
  const ddRum = getDDRUM();
  if (!ddRum) {
    return;
  }
  ddRum.addAction(action, data);
}
